<template>
    <ui-modal ref="modal" :title="lead ? 'Lost Lead' : 'Lost Leads'" dismiss-on="close-button esc">
        <ui-select
            :label="lead ? 'Why did we lose ' + lead.contact.primary_display_as + '\'s business?' : 'Why did we lose the selected leads?'"
            placeholder="Select reason"
            v-model="outcome_reason"
            :options="outcomeReasons"
            :disabled="isBusy"
        ></ui-select>
        <ui-textbox
            v-model="outcome_notes"
            multi-line
            :rows="3"
            :disabled="isBusy"
            placeholder="Additional notes"
        ></ui-textbox>
        <ui-button @click="save" color="primary" :disabled="isBusy || !outcome_reason || !outcome_reason.label">Save</ui-button>
    </ui-modal>
</template>

<script>
import {LeadResource} from "../../classes/Api/Lead";
import DealerKit from "../../api";

export default {
    props: {
        lead: {
            type: Object,
            default: null
        },
        leads: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            outcomeReasons: [],
            outcome_notes: '',
            outcome_reason: '',
            isBusy: false,
            pendingLeads: []
        }
    },
    methods: {
        open() {
            this.outcome_notes = ''
            this.outcome_reason = ''
            this.pendingLeads = this.lead ? [this.lead] : this.leads.slice()

            this.isBusy = true

            DealerKit.leads.getlostLeadOutcomes().then(r => {
                this.outcomeReasons = r.data.data.map(r => {
                    return {
                        label: r.label,
                        value: r.label
                    }
                })

                this.isBusy = false
            }).catch(() => {
                this.isBusy = false
            })

            this.$refs.modal.open()
        },
        close() {
            this.$refs.modal.close()
        },
        save() {
            if (this.isBusy || !this.outcome_reason || !this.outcome_reason.label || !this.pendingLeads.length) {
                return
            }

            this.isBusy = true;
            const outcome = { outcome_notes: this.outcome_notes, outcome_reason: this.outcome_reason.label }

            Promise.all(this.pendingLeads.map(lead => {
                return LeadResource.lost(lead.id, outcome).then(() => ({ lead, saved: true })).catch(error => {
                    handleApiError(error)
                    return { lead, saved: false }
                })
            })).then(results => {
                this.pendingLeads = results.filter(result => !result.saved).map(result => result.lead)

                if (!this.pendingLeads.length) {
                    this.close()
                    this.$emit('lost')
                } else if (results.some(result => result.saved)) {
                    this.$emit('updated')
                }
            }).finally(() => { this.isBusy = false })
        }
    }
}
</script>

<style scoped>

</style>
